import { postJson, ApiSuccess } from './client';
import type { SubscribeFormValues } from '../features/subscribe/SubscribeFormSchema';

export interface SubscribeRequest extends SubscribeFormValues {
  slug: string;
  recaptchaToken: string;
}

/** POST /subscribe — server validates, verifies reCAPTCHA, calls WLS, and returns the leadId as
 *  orderId. */
export function submitSubscribe(payload: SubscribeRequest): Promise<ApiSuccess> {
  return postJson('/subscribe', payload);
}

export interface SyneriseFallbackRequest {
  slug: string;
  formName?: string;
  orderId: string | number;
  email?: string;
  phone?: string;
  firstName?: string;
  lastName?: string;
  agreeNewsletter?: boolean;
  agreeTestDrive?: boolean;
  extraCheckbox1?: boolean;
  extraCheckbox2?: boolean;
}

/** POST /synerise-fallback — called by ThankYouPage only when the `_snrs_uuid` cookie is absent. */
export function submitSyneriseFallback(payload: SyneriseFallbackRequest): Promise<ApiSuccess> {
  return postJson('/synerise-fallback', payload);
}
